export default "__VITE_ASSET__dW$3L7E9__"